import { render, staticRenderFns } from "./C-Profile.vue?vue&type=template&id=09c546fa&"
import script from "./C-Profile.vue?vue&type=script&lang=js&"
export * from "./C-Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports